export default "__VITE_ASSET__B2KgLLJ4__"